<template>
  <div class="step col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-3">
    <div class="row">
      
      <div class="step-info col-xs-12 col-md-3 pull-right" v-if="isNumbered">
        <h3 class="step-info step-info__name">
          {{stepName}}
        </h3>
        <span class="step-info step-info__number hidden-xs hidden-sm">
          {{stepNumber}}
        </span>
      </div>
      
      <div class="step-form col-xs-12 col-md-9" :class="customFormClass">
        <div class="row">
          <div class="step-form__container" :style="customStyle">
            <slot name="form-main-content">
              <template slot="toolbar"><slot name="toolbar" /></template>
            </slot>
          </div>
          <slot name="form-extra-content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepCard',
  props: {
    customStyle: {
      type: Object,
      default: function() {
        return {}
      },
    },
    customFormClass: {
      type: String,
      required: false,
    },
    stepName: {
      type: String,
      required: false,
    },
    stepNumber: {
      type: String,
      required: false
    },
  },
  computed: {
    isNumbered() {
      return this.stepName
    },
  },
}
</script>

<style lang="scss">

.step {
  font-weight: 600;
  margin-top: 14px;
}

.step-form {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  background-color: #fff;
  border-radius: 2px;

  &__container {
    padding: 17px 14px 10px 14px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &__message {
    padding-bottom: 0;
  }

  &--active {
    border: 1px solid #616166;
    border-radius: 2px;
  }
}

.step-info {

  &__name {
    font-size: 13px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.23;
    letter-spacing: normal;
    color: #5e5d5d;
    padding-top: 19px;
  }

  &__number {
    font-size: 130px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 0.77;
    letter-spacing: normal;
    color: #5e5d5d;
    opacity: 0.08;
  }

  @media (max-width: 992px) {
    text-align: center;
    margin-bottom: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/step/StepCard.vue